import React from 'react';
import { motion } from 'framer-motion';
import { overlayMotion } from '../../../data/MotionVars';

import './Overlay.css'

const overlay = (props) => (

  <motion.section {...overlayMotion} {...props} changeEnterMall={props.handleEnterMall} className="HeroBackground" >
    { props.children}
  </motion.section>
);

export default overlay;